import React, { useEffect } from "react";
import { Row, Col, Form } from "antd";
import CasePaymentsName from "./case-payments-name";
import CasePaymentsCost from "./case-payments-cost";
import CasePaymentsBonds from "./case-payments-bonds";
import CasePaymentsRestitution from "./case-payments-restitution";
import { buildSummaryRequest } from "../../../state/connect-api";
import { updateCaseMaster } from "../../../state/globalStore";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useGetCasePaymentsMutation } from "../../../state/globalApi";

const CasePayments = () => {
  const [form] = Form.useForm();
  const { activeCaseNumber, caseMaster } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const [getCasePayments] = useGetCasePaymentsMutation();

  useEffect(() => {
    const lookupRequest = buildSummaryRequest(activeCaseNumber);
    const fetch = async () => {
      const payments = await getCasePayments(lookupRequest).unwrap();
      dispatch(updateCaseMaster({ payments: payments }));
    };

    fetch();
  }, [activeCaseNumber, dispatch, getCasePayments]);

  return (
    <Row gutter={[16, 16]}>
      <Col xl={16} lg={16} md={16} sm={24} xs={24}>
        <CasePaymentsName form={form} caseMaster={caseMaster} />
      </Col>
      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
        <CasePaymentsCost form={form} caseMaster={caseMaster} />
      </Col>
      <Col xl={11} lg={11} md={11} sm={23} xs={23}>
        <CasePaymentsBonds form={form} caseMaster={caseMaster} />
      </Col>
      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
        <CasePaymentsRestitution form={form} caseMaster={caseMaster} />
      </Col>
    </Row>
  );
};

export default CasePayments;
